'use client'

import { useEffect } from 'react'
import { usePathname } from 'next/navigation'
import { initRum, rumSetView } from '@/lib/rum'
import { initSessionReplay } from '@/lib/session-replay'

export function RumInitializer() {
  const pathname = usePathname()

  useEffect(() => {
    void initRum()
    void initSessionReplay()
  }, [])

  useEffect(() => {
    if (pathname) rumSetView(pathname)
  }, [pathname])

  return null
}
